import { render, staticRenderFns } from "./VideoDashboard.vue?vue&type=template&id=6cfc3055&scoped=true&"
import script from "./VideoDashboard.vue?vue&type=script&lang=js&"
export * from "./VideoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VideoDashboard.vue?vue&type=style&index=0&id=6cfc3055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc3055",
  null
  
)

component.options.__file = "VideoDashboard.vue"
export default component.exports